import { StatusDisplay } from "./StatusDisplay";

interface StatusChangeSummaryProps {
  requestTitle: string;
  currentStatus: string;
  newStatus: string;
}

export const StatusChangeSummary = ({ 
  requestTitle, 
  currentStatus, 
  newStatus 
}: StatusChangeSummaryProps) => {
  return (
    <div className="rounded-lg bg-gray-50 p-4">
      <div className="mb-2 flex items-center justify-between">
        <span className="font-medium text-gray-700 text-sm">
          Request:
        </span>
        <span className="font-medium text-gray-900 text-sm">
          {requestTitle}
        </span>
      </div>
      <div className="flex items-center justify-between">
        <span className="font-medium text-gray-700 text-sm">
          Status Change:
        </span>
        <div className="flex items-center space-x-2">
          <StatusDisplay 
            status={currentStatus} 
            className="font-medium text-sm"
          />
          <span className="text-gray-400">→</span>
          <StatusDisplay 
            status={newStatus} 
            className="font-medium text-sm"
          />
        </div>
      </div>
    </div>
  );
};
